import { render } from "./UserPic.vue?vue&type=template&id=ee00b5fa"
import script from "./UserPic.vue?vue&type=script&lang=js"
export * from "./UserPic.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__